import React, { forwardRef } from 'react';

import { bemCssModules } from '@utils';

import { useStore } from '@modules';

import Modal from '@components/NewModal';

import Footer from './Footer';
import PrivateContent from './PrivateContent';
import PublicContent from './PublicContent';

import style from './Menu.scss';

const cn = bemCssModules(style, 'Menu');

export type TMenu = {
  className?: string;
  isOpen?: boolean;
};

const Menu = forwardRef<HTMLDivElement, TMenu>((props, ref) => {
  const { className, isOpen } = props;

  const [{ login }] = useStore();

  return (
    <Modal
      ref={ref}
      className={cn(null, [className])}
      isOpen={isOpen}
      hideCloseButton
      hideMobileCloseButton
      slide={false}
      fade
      disableScroll
    >
      <div className={cn('wrapper')}>
        <div className={cn('content')}>
          {login.isLoggedIn ? <PrivateContent /> : <PublicContent />}
        </div>
        <Footer />
      </div>
    </Modal>
  );
});

export default Menu;
